import CustomButton from "../kits/button/CustomButton";
import DatePiker from "../datepiker/datePiker";
import ToastCustomize from "../kits/ToastCustomize";

export default function Report({
  reportData,
  reportDataHandler,
  reportDataError,
  filter,
}) {
  return (
    <div className="d-flex flex-wrap">
      <div>
        {" "}
        <div className="d-flex  align-items-center mx-1 my-1 report-input">
          <label className="label " style={{ fontSize: 13 }}>
            گزارش از تاریخ:
          </label>
          <DatePiker
            width="120px"
            inputSize="text"
            value={reportData?.from}
            setValue={(e) => {
              reportDataHandler({ from: e });
            }}
          ></DatePiker>
        </div>
        <div className="validate-txt">{reportDataError?.from}</div>
      </div>
      <div>
        <div
          className="d-flex align-items-center me-3 ms-3 my-1 report-input"
          onClick={() => {
            if (reportData.from == "") {
              ToastCustomize({
                mainText: "لطفا ابتدا از تاریخ را انتخاب کنید.",
                duration: 3000,
                toastType: "danger",
                color: "danger",
                position: "top-center",
                hasHeader: false,
              });
            }
          }}
        >
          <label className="label" style={{ fontSize: 13 }}>
            {" "}
            تا تاریخ:
          </label>
          <DatePiker
            width="120px"
            inputSize="text"
            value={reportData?.to}
            setValue={(e) => {
              reportDataHandler({ to: e });
            }}
            minDate={reportData.from}
            readOnly={reportData.from == "" ? true : false}
          ></DatePiker>
        </div>
        <div className="validate-txt">{reportDataError?.to}</div>
      </div>

      <CustomButton
        color="warning"
        size="medium"
        style={{ width: 80 }}
        className="justify-content-center button ms-auto align-self-end mt-1 mb-4"
        state="normal"
        circle={false}
        onClick={(e) => {
          filter();
        }}
      >
        اعمال
      </CustomButton>
    </div>
  );
}
